import Model from '@/models/Model'

export default class WhUnitOfMeasurement extends Model {
    resource() {
        return 'wh_unit_of_measurement'
    }
}